import { criarFinalizador } from '@/uteis/action/devolver/finalizador'

export const desarquivar = (dados, dadosSessao) => {
  var desarquivamento = {
    ...dados,
    usuario: criarFinalizador(dadosSessao, true)
  }

  return desarquivamento
}
